import React, { useState, useEffect, useRef } from "react";
import KpiCard from "../components/KpiCard";
import ReusableBarChart from "../components/ReusableBarChart";
import ConversionFunnel from "../components/ConversionFunnel.jsx";
import TrendCharts from "../components/TrendCharts.jsx";
import AdsPerformance from "../components/AdsPerformance.jsx"
import "../App.css";
import { api } from "../utils/api";
import FunnelComparison from "../components/FunnelComparison.jsx"




export default function Overview() {  


  const [zomatoData, setZomatoData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [previousMonthData, setPreviousMonthData] = useState(null);
  const [currentNetSales, setCurrentNetSales] = useState(null);
  const [previousNetSales, setPreviousNetSales] = useState(null);
  const [resturantHeader, setRestaurantHeader] =  useState(null)
  const [activeMetric, setActiveMetric] = useState("orders");
  const [selectedRestData, setselectedRestData] = useState("");
  const [periodList, setPeriodList] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedPeriodSecFunnel, setSelectedPeriodSecFunnel] = useState("");
  const [selectedMenuOpen, setSelectMenuOpen] = useState("")
  const [selectedCartBuild, setSelectCartBuild] = useState("")
  const [funnelOrder, setfunnelOrder] = useState("")
  const [selectedMenuOpenSecond, setSelectMenuOpenSecond] = useState("")
  const [selectedCartBuildSecond, setSelectCartBuildSecond] = useState("")
  const [funnelOrderSecond, setfunnelOrderSecond] = useState("")
  const [restaurant, setRestaurant] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [headerMonth, setheaderMonth] = useState()
  const [restaurantNames, setrestaurantNames] = useState("")
  const [selectheaderDate, setHeaderDates] = useState("")
  const [overallConvFunnel, setOverallConvFunnel] = useState("")
  const [overallSecConvFunnel, setSecOverallConvFunnel] = useState("")


  const dropdownRef = useRef(null);



  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true);
  
        // Dropdown API
        const dropdownData = await api("/restaurant-dropdown");
  
        setrestaurantNames(dropdownData)
  
        // Selected restaurant
        const firstRestaurant = dropdownData?.[13]?.value;
  
        if (!firstRestaurant) {
          console.error("Restaurant not found");
          return;
        }
  
        // Details API
        const detailsData = await api(
          `/combined/restaurant/${firstRestaurant}`
        );
  
  
        const summary = detailsData?.summary || [];
  
        if (summary.length < 2) {
          console.error("Not enough summary data");
          return;
        }
  
        // Store full API response
        setZomatoData(detailsData);
  
        // Period list
        const allPeriods = dateConvert(summary);
        setPeriodList(allPeriods);
        setHeaderDates(allPeriods)
  
        // Latest months
        const currentMonth = summary[summary.length - 1];
        const prevMonth = summary[summary.length - 2];
  


        const overallConversion = ((currentMonth?.orderMake / currentMonth?.menuOpen) * 100).toFixed(1)
        const overallSecConversion = ((prevMonth?.orderMake / prevMonth?.menuOpen) * 100).toFixed(1)



        setOverallConvFunnel(overallConversion)
        setSecOverallConvFunnel(overallSecConversion)

              
  
        // Net sales
        const currNetSale =
          (currentMonth?.gmv || 0) -
          (currentMonth?.discount || 0);
  
        const prevNetSale =
          (prevMonth?.gmv || 0) -
          (prevMonth?.discount || 0);

        setselectedRestData(summary)

  
        // Header
        setRestaurantHeader(
          detailsData?.restaurant_name || ""
        );
  
        // Net sales
        setCurrentNetSales(currNetSale);
        setPreviousNetSales(prevNetSale);
  
        // Month data
        setCurrentMonthData(currentMonth);
        setPreviousMonthData(prevMonth);
  
        // Funnel current
        setSelectMenuOpen(currentMonth?.menuOpen || 0);
        setSelectCartBuild(currentMonth?.cartbuild || 0);
        setfunnelOrder(currentMonth?.orderMake || 0);
  
        // Funnel previous
        setSelectMenuOpenSecond(prevMonth?.menuOpen || 0);
        setSelectCartBuildSecond(prevMonth?.cartbuild || 0);
        setfunnelOrderSecond(prevMonth?.orderMake || 0);
  
        // Periods
        setSelectedPeriod(currentMonth?.period || "");
        setSelectedPeriodSecFunnel(prevMonth?.period || "");
        setheaderMonth(currentMonth?.period || "");
  
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoading(false);
      }
    }
  
    loadData();
  }, []);
  

  // useEffect(() => {
  //   api('/home')
  //   .then(data => {
  //     setTimeout(() => {
  //       setZomatoData(data);
  //       setIsLoading(false);
  //     }, 1000);
  //     const resData = data.zaika_fun_dining
  //     const allperiods = dateConvert(resData)
  //     setPeriodList(allperiods)
      

  //     const currentMonth = resData[resData.length - 1]
  //     const prevMonth = resData[resData.length -2]
  //     console.log("currentMonth",currentMonth.discount)
  //     const currNetSale = currentMonth?.gmv - currentMonth?.discount
  //     const prevNetSale = prevMonth?.gmv - prevMonth?.discount

  //     setselectedRestData(resData)
  //     setRestaurantHeader(currentMonth.rest_name)
  //     setCurrentNetSales(currNetSale)
  //     setPreviousNetSales(prevNetSale)
  //     setCurrentMonthData(currentMonth)
  //     setPreviousMonthData(prevMonth)
  //     setSelectMenuOpen(currentMonth?.menuOpen)
  //     setSelectCartBuild(currentMonth.cartbuild)
  //     setfunnelOrder(currentMonth.orderMake)
  //     setSelectMenuOpenSecond(prevMonth?.menuOpen)
  //     setSelectCartBuildSecond(prevMonth.cartbuild)
  //     setfunnelOrderSecond(prevMonth.orderMake)
  //     setSelectedPeriod(currentMonth.period)
  //     setSelectedPeriodSecFunnel(prevMonth.period)
  //     setheaderMonth(currentMonth.period)
      


  //   })
  //     .catch(console.error);
  // }, []);


  




  const dateConvert = (resData) =>{

    return resData.map(item => ({
      raw: item.period,
      formatted: formatPeriod(item.period)
    }))

  }
  

 

  // const funnel_metrics = dataValue.funnel_metrics



  // const latestFunnelMetrics = funnel_metrics[funnel_metrics.length - 1]
  // const prevFunnelMetrics = funnel_metrics[funnel_metrics.length - 2]


   
const formatPeriod = (period) => {
  const [year, month] = period.split("-");

  const date = new Date(year, month - 1); // month -1 because JS months start from 0

  return date.toLocaleString("en-US", {
    month: "short",
    year: "numeric",
  });
};


// const allperiods = funnel_metrics.map(item => ({
//   raw: item.period,
//   formatted: formatPeriod(item.period)
// }))





  //const conversionTrendData = buildConversionTrend(dataValue, "C2O");



  // const latestFunnelMetrics = {
  //   menuOpen: 12450,
  //   cartBuild: 4980,
  //   orders: 2130
  // };

  // const prevFunnelMetrics = {
  //   menuOpen: 11820,
  //   cartBuild: 5200,
  //   orders: 2210
  // };
  
  const MIN_FUNNEL_VALUE = 1;
  
  const STATIC_FUNNEL_VALUES = [100, 70, 35];



 
  const funnellatestFunnelMetrics = [
    {
      label: `Menu Opens`,
      value: STATIC_FUNNEL_VALUES[0],
      actual: selectedMenuOpen,
      fill: "#6366F1"
    },
    {
      label: `Cart Builds`,
      value: STATIC_FUNNEL_VALUES[1],
      actual: selectedCartBuild,
      fill: "#22C55E"
    },
    {
      label: `Orders`,
      value: STATIC_FUNNEL_VALUES[2],
      actual: funnelOrder,
      fill: "#F97316"
    }
  ];

  const funnelprevFunnelMetrics = [
    {
      label: `Menu Opens`,
      value: STATIC_FUNNEL_VALUES[0],
      actual: selectedMenuOpenSecond,
      fill: "#5B5FC7"
    },
    {
      label: `Cart Builds`,
      value: STATIC_FUNNEL_VALUES[1],
      actual: selectedCartBuildSecond,
      fill: "#1F9D55"
    },
    {
      label: `Orders`,
      value: STATIC_FUNNEL_VALUES[2],
      actual: funnelOrderSecond,
      fill: "#D97706"
    }
  ];

  // 🚨 Auto flag bad funnel
  // const cartDrop =
  //   ((thisMonth.menuOpen - thisMonth.cartBuild) / thisMonth.menuOpen) * 100;

    const calcChange = (curr, prev) => {
      if (!prev || prev === 0) {
        return curr > 0 ? "100.0" : "0.0";
      }
    
      return (((curr - prev) / prev) * 100).toFixed(1);
    };

    const calcChangeDrop = (current, previous) =>
      previous === 0 ? 0 : current - previous;




    const onSelectedSecondDate = (selectedDate)=>{

      const funnel_metrics = selectedRestData


    const funnelData = funnel_metrics.filter(
      (values) => values.period === selectedDate
    );

    const overallConversion = ((funnelData[0].orderMake / funnelData[0].menuOpen) * 100).toFixed(1)
    setSecOverallConvFunnel(overallConversion)
    setfunnelOrderSecond(funnelData[0].orderMake)
    setSelectMenuOpenSecond(funnelData[0].menuOpen)
    setSelectCartBuildSecond(funnelData[0].cartbuild)

    }

const onSelectedDate = (selectedDate) =>{

    const funnel_metrics = selectedRestData


    


    const funnelData = funnel_metrics.filter(
      (values) => values.period === selectedDate
    );

    const overallConversion = ((funnelData[0].orderMake / funnelData[0].menuOpen) * 100).toFixed(1)



    setOverallConvFunnel(overallConversion) 
    setfunnelOrder(funnelData[0].orderMake)
    setSelectMenuOpen(funnelData[0].menuOpen)
    setSelectCartBuild(funnelData[0].cartbuild)

  }



  const onSelectHeaderDate = (value) =>{

    const index = selectedRestData.findIndex(
      (item) => item.period === value
    );
    
    let currentMonth = null;
    let prevMonth = "";
    
    if (index !== -1) {
      currentMonth = selectedRestData[index];
    
      // Previous month exists
      if (index > 0) {
        prevMonth = selectedRestData[index - 1];
      }
    }

    const currNetSale =
    (currentMonth?.gmv || 0) -
    (currentMonth?.discount || 0);

  const prevNetSale =
    (prevMonth?.gmv || 0) -
    (prevMonth?.discount || 0);

    setCurrentNetSales(currNetSale);
    setPreviousNetSales(prevNetSale);
    

    setCurrentMonthData(currentMonth);
    setPreviousMonthData(prevMonth);

}

  const newResData =  async (value, label)=>{

    try {
      setIsLoading(true);
  
      // UI updates
      setRestaurant(value);
      setSearch(label);
      setOpen(false);
  
      // API Call
      const detailsData = await api(
        `/combined/restaurant/${value}`
      );
    
      const summary = detailsData?.summary || [];
  
      if (summary.length < 2) return;
  
      const currentMonth = summary[summary.length - 1];
      const prevMonth = summary[summary.length - 2];

     setselectedRestData(summary)

     const overallConversion = ((currentMonth.orderMake / currentMonth.menuOpen) * 100).toFixed(1)
     const overallSecConversion = ((prevMonth.orderMake / prevMonth.menuOpen) * 100).toFixed(1)


     setOverallConvFunnel(overallConversion)
     setSecOverallConvFunnel(overallSecConversion)

  
      // Net Sales
      const currNetSale =
        (currentMonth?.gmv || 0) -
        (currentMonth?.discount || 0);
  
      const prevNetSale =
        (prevMonth?.gmv || 0) -
        (prevMonth?.discount || 0);
  
      // Store data
      setZomatoData(detailsData);
  
      const allPeriods = dateConvert(summary);
      setPeriodList(allPeriods);
  
      setRestaurantHeader(
        detailsData?.restaurant_name || ""
      );
  
      setCurrentNetSales(currNetSale);
      setPreviousNetSales(prevNetSale);
  
      setCurrentMonthData(currentMonth);
      setPreviousMonthData(prevMonth);
  
      // Funnel current
      setSelectMenuOpen(currentMonth?.menuOpen || 0);
      setSelectCartBuild(currentMonth?.cartbuild || 0);
      setfunnelOrder(currentMonth?.orderMake || 0);
  
      // Funnel previous
      setSelectMenuOpenSecond(prevMonth?.menuOpen || 0);
      setSelectCartBuildSecond(prevMonth?.cartbuild || 0);
      setfunnelOrderSecond(prevMonth?.orderMake || 0);
  
      // Periods
      setSelectedPeriod(currentMonth?.period || "");
      setSelectedPeriodSecFunnel(prevMonth?.period || "");
      setheaderMonth(currentMonth?.period || "");
  
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }








    

    // const restVal = selectedResName.toLowerCase()
    // const resData = zomatoData[restVal]
    // const allperiods = dateConvert(resData)
    // setselectedRestData(resData)
    // const currentMonth = resData[resData?.length - 1]
    // const prevMonth = resData[resData?.length -2]
    // const currNetSale = currentMonth.gmv - currentMonth.discount
    // const prevNetSale = prevMonth.gmv - prevMonth.discount
    // setCurrentNetSales(currNetSale)
    // setPreviousNetSales(prevNetSale)
    // setCurrentMonthData(currentMonth)
    // setPreviousMonthData(prevMonth)
    // setRestaurantHeader(selectedResLabel)
    // setheaderMonth(currentMonth.period)
    // setPeriodList(allperiods)
    // setSelectMenuOpen(currentMonth.menuOpen)
    // setSelectCartBuild(currentMonth.cartbuild)
    // setfunnelOrder(currentMonth.orderMake)
    // setSelectMenuOpenSecond(prevMonth.menuOpen)
    // setSelectCartBuildSecond(prevMonth.cartbuild)
    // setfunnelOrderSecond(prevMonth.orderMake)
    // setSelectedPeriod(currentMonth.period)
    // setSelectedPeriodSecFunnel(prevMonth.period)

    
  }




useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
  
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);


  // if (!dataValue?.order_metrics?.length) {
  //   return <div className="p-6">Loading dashboard…</div>;
  // }
  


  return (
    <>
    {
      isLoading? <span class="loader"> </span>
      :
      <>
<div className="overview-page">
  <div className="overview-content">
    <div className="overview-header">
      <div>
        <h1 className="overview-title">Overview</h1>
        <p className="overview-subtitle">Track restaurant performance, sales, and conversion health.</p>
      </div>
    </div>

       <div
  ref={dropdownRef}
  className="relative w-full transition-shadow focus-within:shadow-md mb-4"
>
  {/* Search Icon */}
  <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
    <svg
      className="w-6 h-6 text-gray-400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z"
      />
    </svg>
  </div>

  {/* INPUT */}
  <input
    type="text"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setOpen(true);
    }}
    onFocus={() => setOpen(true)}
    placeholder="Search restaurant..."
    className="
      w-full
      pl-12
      pr-4
      py-3
      border
      rounded-lg
      text-base
      bg-white
      focus:outline-none
      focus:ring-2
      focus:ring-indigo-500
    "
  />

  {/* DROPDOWN */}
  {open && (
    <div
      className="
        absolute
        top-full
        left-0
        z-50
        mt-2
        w-full
        bg-white
        border
        rounded-lg
        shadow-lg
        max-h-72
        overflow-y-auto
      "
    >
      {restaurantNames
        .filter((r) =>
          r.label.toLowerCase().includes(search.toLowerCase())
        )
        .map((r) => (
          <div
            key={r.value}
            onClick={() => {
              newResData(r.value, r.label);
            }}
            className="
              px-4
              py-3
              cursor-pointer
              hover:bg-gray-100
              text-base
            "
          >
            {r.label}
          </div>
        ))}

      {restaurantNames.filter((r) =>
        r.label.toLowerCase().includes(search.toLowerCase())
      ).length === 0 && (
        <div className="px-4 py-3 text-gray-400 text-base">
          No results
        </div>
      )}
    </div>
  )}
</div>
 
  

<div className="overview-toolbar">
 <div className="overview-restaurant">
    <span>Restaurant</span>
    {resturantHeader}
</div>
<div>
        <select
          value={headerMonth}
          onChange={(e) => 
          {
            onSelectHeaderDate(e.target.value)
            setheaderMonth(e.target.value)
          }  
          }
          className="overview-period-select"
        >
          {selectheaderDate.map((p) => (
            <option key={p.raw} value={p.raw}>
              {p.formatted}
            </option>
          ))}
        </select>
    </div>

</div>

      {/* KPI STRIP (lightweight) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">


{/* Example KPI */}
<KpiCard
       title="Orders"
       value={currentMonthData.orders}
       percentage={ previousMonthData ? `${calcChange(currentMonthData?.orders,previousMonthData?.orders)}%`: ""}
       isUp={previousMonthData? currentMonthData?.orders > previousMonthData?.orders: null}
       gradient="bg-gradient-to-r from-blue-500 to-sky-500"
       dataKey="orders"
   
     />
 <KpiCard
       title="Gross Sales"
       value={`₹${currentMonthData.gmv.toLocaleString()}`}
       percentage={ previousMonthData ? `${calcChange(currentMonthData?.gmv,previousMonthData?.gmv)}%`: ""}
       isUp={previousMonthData? currentMonthData?.gmv > previousMonthData?.gmv: null}
       gradient="bg-gradient-to-r from-blue-500 to-sky-500"
       dataKey="GMV"
   
     />
    <KpiCard
        title="Discount"
        value={`₹${currentMonthData.discount.toLocaleString()}`}        
        percentage={ previousMonthData ? `${calcChange(currentMonthData?.discount,previousMonthData?.discount)}%`: ""}
        isUp={previousMonthData? currentMonthData?.discount > previousMonthData?.discount: null}
        gradient="bg-gradient-to-r from-blue-500 to-sky-500"
        dataKey="gmv"

      />
      <KpiCard
       title="Net Sales "
       value={`₹${Math.round(currentNetSales).toLocaleString()}`}
       percentage={ previousMonthData ? `${calcChange(currentNetSales,previousNetSales)}%`: ""}
       isUp={previousMonthData? currentNetSales > previousNetSales: null}
       gradient="bg-gradient-to-r from-blue-500 to-sky-500"
       dataKey="orders"
     />
     <KpiCard
          title="Average Order Value"
          value={`₹${currentMonthData.aov}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.aov,previousMonthData?.aov)}%`: ""}
          isUp={previousMonthData? currentMonthData?.aov > previousMonthData?.aov: null}
          gradient="bg-gradient-to-r from-blue-500 to-sky-500"
          dataKey="aov"
        />
      <KpiCard
          title="Ad Spent"
          value={`₹${currentMonthData.billed_amount.toLocaleString()}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.billed_amount,previousMonthData?.billed_amount)}%`: ""}
          isUp={previousMonthData? currentMonthData?.billed_amount > previousMonthData?.billed_amount: null}
          gradient="bg-gradient-to-r from-blue-500 to-sky-500"
          dataKey="adsBilled"
        />
          <KpiCard
          title="Total Burn"
          value={`₹${Math.round(currentMonthData?.burn ?? 0).toLocaleString()}`}
          percentage={ previousMonthData ? `${calcChange(currentMonthData?.burn,previousMonthData?.burn)}%`: ""}
          isUp={previousMonthData? currentMonthData?.burn > previousMonthData?.burn: null}
          gradient="bg-gradient-to-r from-blue-500 to-sky-500"
          dataKey="zomatoBurn"


      />
      <KpiCard
        title="Ads ROI"
        value={currentMonthData?.roi?.toLocaleString()}
        percentage={ previousMonthData ? `${calcChange(currentMonthData?.roi,previousMonthData?.roi)}%`: ""}
        isUp={previousMonthData? currentMonthData?.roi > previousMonthData?.roi: null}
        gradient="bg-gradient-to-r from-blue-500 to-sky-500"
        dataKey="roi"
      />
    
      </div>


      <div className="overview-chart-card bg-white rounded-xl p-4 mt-5">

<div className="flex gap-2 mb-4 mt-6 ml-0 sm:ml-4 md:ml-[55px]">
  {["orders", "gmv", "aov", "discount"].map((metric) => (
    <button
      key={metric}
      onClick={() => setActiveMetric(metric)}
      className={`px-4 py-2 rounded-md text-sm font-medium transition
        ${activeMetric === metric
          ? "bg-indigo-600 text-white"
          : "bg-gray-200 text-gray-700 hover:bg-gray-300"}
      `}
    >
      {metric.toUpperCase()}
    </button>
  ))}
</div>


<ReusableBarChart
  data={selectedRestData}
  metric={activeMetric}
/>
</div>



       
      <section className="overview-funnel-card funnel-comparison mt-5 mb-5">
        <div className="funnel-comparison__header">
          <div>
            <p className="funnel-comparison__eyebrow">Funnel Conversion health</p>
            <p className="funnel-comparison__description">Compare the drop-off across every step in two selected periods.</p>
          </div>
          <div className="funnel-comparison__steps">
            <span>Menu opens</span><b>→</b><span>Cart builds</span><b>→</b><span>Orders</span>
          </div>
        </div>

        <div className="funnel-comparison__grid">
          <article className="funnel-panel funnel-panel--primary">
            <div className="funnel-panel__header">
              <div>
                <p>Selected period</p>
                <h3>Funnel snapshot</h3>
              </div>
              <select
                value={selectedPeriod}
                onChange={(e) => {
                  onSelectedDate(e.target.value);
                  setSelectedPeriod(e.target.value);
                }}
                className="funnel-panel__select"
              >
                {periodList.map((p) => (
                  <option key={p.raw} value={p.raw}>{p.formatted}</option>
                ))}
              </select>
            </div>

            <div className="funnel-panel__chart">
              <ConversionFunnel data={funnellatestFunnelMetrics} variant="journey" />
            </div>

            <div className="funnel-panel__conversion">
              <div>
                <span>End-to-end conversion</span>
                <p>Menu Opens → Orders</p>
              </div>
              <strong>{overallConvFunnel}%</strong>
            </div>
          </article>

          <article className="funnel-panel funnel-panel--secondary">
            <div className="funnel-panel__header">
              <div>
                <p>Comparison period</p>
                <h3>Funnel snapshot</h3>
              </div>
              <select
                value={selectedPeriodSecFunnel}
                onChange={(e) => {
                  setSelectedPeriodSecFunnel(e.target.value);
                  onSelectedSecondDate(e.target.value);
                }}
                className="funnel-panel__select"
              >
                {periodList.map((p) => (
                  <option key={p.raw} value={p.raw}>{p.formatted}</option>
                ))}
              </select>
            </div>

            <div className="funnel-panel__chart">
              <ConversionFunnel data={funnelprevFunnelMetrics} variant="journey" />
            </div>

            <div className="funnel-panel__conversion">
              <div>
                <span>End-to-end conversion</span>
                <p>Menu Opens → Orders</p>
              </div>
              <strong>{overallSecConvFunnel}%</strong>
            </div>
          </article>
        </div>
      </section>

<div className="dashboardRow">
  <TrendCharts data={selectedRestData} />
  <AdsPerformance data={selectedRestData} />
</div>
    
    </div>
    </div>




      
      </>
    }
    </>
      );
}


  
